import { Component, ElementRef, OnInit, ViewChild, ChangeDetectionStrategy } from "@angular/core";
import { ToastService } from "@app/services/toast.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { PipelineService } from "../../services/pipeline.service";
import { ActivatedRoute, Router } from "@angular/router";
import { DealerService } from "../../services/dealer.service";
import { NgxSpinnerService } from "ngx-spinner";
import { Subscription } from "rxjs";
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { DatePipe } from "@angular/common";
import { NgStyle } from '@angular/common';
import { NumberPipe } from '../../shared-components/custom-pipe/numberformat.pipe';
import { FormsModule } from '@angular/forms';
import { NgOtpInputComponent } from 'ng-otp-input';

@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    selector: 'app-cif-customer',
    imports: [
      NgStyle,
      NumberPipe,
      DatePipe,
      FormsModule,
      NgOtpInputComponent
    ],
    templateUrl: './cif-customer.component.html',
    styleUrl: './cif-customer.component.scss',})
export class CifCustomerComponent implements OnInit {
  isFieldDisabled = true;
  cifDetails: any = {
    customer_details: {
      customer_first_name: '',
      customer_last_name: '',
      sap_customer_code: '',
      opty_id: '',
      vas_order_number: '',
      customer_email: '',
      customer_mobile_number: '',
      customer_address_line_1: '',
      customer_pan_number: '',
      customer_gstin_number: '',
      customer_tan_number: '',
      kyc_documents_submitted: [] as string[]
    },
    vehicle_details: {
      pl: '',
      chassis_number: '',
      registration_number: '',
      product: '',
      application: '',
      terrain: '',
    },
    amc_details: {
      service_product_type: '',
      vas_product_code: '',
      net_payable_amount: '',
      cgst_amount: 0,
      tds_amount: 0,
      total_amount: 0
    },
    contract_summary: {
      contract_kms_or_hrs: '',
      start_kms_or_hrs: '',
      end_kms_or_hrs: '',
      start_date: '',
      end_date: '',
      sale_date: ''
    },
    payment_details: {
      receipt_number: '',
      receipt_date: '',
      payment_mode: '',
      payment_method: '',
      payment_type: '',
      cheque_number: '',
      bank: '',
      booking_amount: 0,
      emi_amount: 0,
      total_number_of_emi: 0,
      emi_dates: '',
      emi_starts_from: ''
    }
  };
  @ViewChild("Panattachmentpopup") Panattachmentpopup: any;
  @ViewChild("previewpopup") previewpopup: any; // Reference to the preview moda
  @ViewChild('gstNotRegisteredRef') gstNotRegisteredRef!: ElementRef;
  @ViewChild('gstRegisteredRef') gstRegisteredRef!: ElementRef;
  termsAndConditionsChecked: boolean = false;
  termsAndConditions2Checked: boolean = false;
  selectedOption: string = '';
  selectedCIFFile: File | null = null;
  //errorMessage: string = "";
  bothChecked: boolean = false;
  buttonText: string = "Send to Customer";
  isDisabled: boolean = false;
  timer: number | null = null;
  timeLeft: number = 10;
  gstAmount: any;
  cifFileName: string | null = null;
  errorMessage: string | null = null;
  maxFileSize = 5 * 1024 * 1024; //5 MB in bytes
  cifFileUrl: string | null = null; // URL to preview the file
  fileRemoved: boolean = false;
  closeResult: any = "";
  imageName: string = "";
  imgPreview: any = "";
  selectedImageFile: File | null = null;
  comment: any = '';
  order_number: any = "";
  // cifDetails: any = null;
  private routeSub: Subscription | undefined;
  showTokenExpiryDiv: boolean = false;
  showTokenAccpetDiv: boolean = false;
  hideAllCode: boolean = true;
  shoMsg = '';
  termsAgree: boolean = false;
  authorize: boolean = false;
  gstNotRegistered = false;
  gstRegistered = false;
  paymentPlanData: any = [];
  showFormattext: any = '';
  showOtp: boolean = true;//true;
  resendBtn: boolean = false;
  otp: string = '';
  isVerifyEnabled: boolean = false; // Verify disabled until timer starts
  isResendEnabled: boolean = false; // Resend disabled at first
  isTimerVisible: boolean = false; // Timer hidden at first
  countdown: number = 180; // 3 minutes in seconds
  interval: any;
  isError: boolean = false;
  disableOtp: boolean = true;
  constructor(
    private pipelineService: PipelineService,
    private toastr: ToastService,
    private modalService: NgbModal,
    private dealerService: DealerService,
    private activatedRoute: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private router: Router,
    private domSanitizer: DomSanitizer, private datePipe: DatePipe
  ) { }
  captchaResponse: string = ''; // Holds the reCAPTCHA response

  ngOnInit() {
    this.routeSub = this.activatedRoute.paramMap.subscribe(paramMap => {
      this.order_number = paramMap.get("id") || '';
      console.log('this.order_number:', this.order_number);

      if (!this.order_number) {
        this.router.navigate(['/404']);
        return;
      }

      this.getCifDetails(this.order_number);
    });
  }
  get documentsSubmitted(): string {
    return this.cifDetails?.customer_details?.kyc_documents_submitted
      ?.map((doc: string) => doc.toUpperCase())
      .join(', ') || '';
  }
  get customerFullName(): string {
    const firstName = this.cifDetails?.customer_details?.customer_first_name || '';
    const lastName = this.cifDetails?.customer_details?.customer_last_name || '';
    return `${firstName} ${lastName}`.trim();
  }
  getCifDetails(orderNumber: string) {
    const rupeeSymbol = '\u20B9';
    this.spinner.show('main');
    const payload = {
      token: this.order_number,
      app_name: "com.tatamotors.vas.customer",
    };

    this.dealerService.getCifDetailsToken(payload).subscribe(
      (response: any) => {
        this.spinner.hide('main');
        if (response.data) {
          this.cifDetails = response.data;
          if (this.cifDetails?.customer_details?.customer_gstin_number) {
            this.gstNotRegistered = false;
            this.gstRegistered = true;
          } else {
            this.gstNotRegistered = true;
            this.gstRegistered = false;
          }
          this.showFormattext = this.cifDetails?.vehicle_details?.is_tipper_vehicle ? 'hrs' : 'kms';
          console.log("Fetched CIF Details:", response);
          this.gstAmount = (response.data.amc_details.cgst_amount + response.data.amc_details.igst_amount + response.data.amc_details.ugst_amount + response.data.amc_details.sgst_amount);
          this.cifDetails.contract_summary.start_date = this.formatToDisplay(response?.data?.contract_summary.start_date);
          this.cifDetails.contract_summary.end_date = this.formatToDisplay(response?.data?.contract_summary.end_date);
          this.cifDetails.contract_summary.sale_date = this.formatToDisplay(response?.data?.contract_summary.sale_date);
          this.cifDetails.payment_details.receipt_date = this.formatToDisplay(response?.data?.payment_details.receipt_date);
          this.cifDetails.payment_details.emi_dates = this.formatToDisplay(response?.data?.payment_details.emi_dates);
          this.cifDetails.payment_details.emi_starts_from = this.formatToDisplay(response?.data?.payment_details.emi_starts_from);
          this.cifDetails.amc_details.total_amount = parseFloat(this.cifDetails.amc_details.total_amount).toFixed(2);
          this.cifDetails.amc_details.tds_amount = parseFloat(this.cifDetails.amc_details.tds_amount).toFixed(2);
          this.gstAmount = parseFloat(this.gstAmount).toFixed(2);
          this.cifDetails.payment_details.booking_amount = parseFloat(this.cifDetails.payment_details.booking_amount).toFixed(2);
          this.cifDetails.payment_details.total_paid_amount = parseFloat(this.cifDetails.payment_details.total_paid_amount).toFixed(2);
          this.cifDetails.payment_details.emi_amount = parseFloat(this.cifDetails.payment_details.emi_amount).toFixed(2);
          this.hideAllCode = true;
        }
        else {
          this.showTokenExpiryDiv = true;
          this.hideAllCode = false;
        }

      },
      (error: any) => {
        this.spinner.hide('main');
        this.isError = true;
        // console.log("API error:", error.error.error);
        this.toastr.error(error?.msg || 'Something went wrong');
        this.hideAllCode = false;
        this.showTokenExpiryDiv = true;
        // this.router.navigateByUrl('/dealer/dashboard')
      }
    );
  }

  //  Start OTP Flow When User Clicks `onSubmitCIF()`
  onSubmitCIF(rejectPopup: any) {
    // this.spinner.show('main');

    // Validate terms and authorization checkboxes
    if (!this.termsAgree || !this.authorize) {
      this.toastr.warning("Please accept the terms and conditions");
      return;
    }

    // GST checkbox validation based on GST number presence
    const gstin = this.cifDetails?.customer_details?.customer_gstin_number;
    if (!gstin && !this.gstNotRegistered) {
      this.toastr.warning("Please confirm that you are not registered under GST");
      this.gstNotRegisteredRef?.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    if (gstin && !this.gstRegistered) {
      this.toastr.warning("Please confirm your GSTN declaration");
      this.gstRegisteredRef?.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    // Proceed with form submission
    this.modalService.open(rejectPopup, { centered: true, size: "sm" });
  }


  //  Call API to generate OTP (Used for first-time and Resend)
  generateOTP() {
    // if (!this.captchaResponse) {
    //   this.toastr.error('Please complete the reCAPTCHA.');
    //   return;
    // }
    this.spinner.show('main');
    const payload = {
      app_name: "com.tatamotors.vas.customer",
      token: this.order_number,
    };

    this.dealerService.sendCIFOtp(payload).subscribe(
      (res: any) => {
        this.spinner.hide('main');
        this.disableOtp = false;
        // this.captchaResponse = ''
        // this.googleCaptcha.resetCaptcha();
        this.toastr.success(res.msg);
        this.isVerifyEnabled = true; // Enable Verify button
        this.isResendEnabled = false; // Disable Resend button
        this.resendBtn = true;
        this.countdown = 180;
        this.isTimerVisible = true;
        this.startResendTimer(); //  Start 3-minute timer
      },
      (error: any) => {
        // this.captchaResponse = ''
        // this.googleCaptcha.resetCaptcha();
        this.spinner.hide('main');
        this.toastr.error(error?.msg || 'Something went wrong');
        this.isResendEnabled = true;
        this.resendBtn = false;

      }
    );
  }
  onOtpChange(otp: any) {
    this.otp = otp;
  }
  //  Call API to verify OTP
  verifyOTP() {
    // if (!this.captchaResponse) {
    //   this.toastr.error('Please complete the reCAPTCHA.');
    //   return;
    // }
    console.log("tets this.otp", this.otp.length)
    if (this.otp.length !== 6) {
      this.errorMessage = "Please enter a 6-digit OTP.";
      return;
    }

    this.spinner.show('main');
    const payload = {
      token: this.order_number,
      otp: this.otp
    };

    this.dealerService.getVerifyOTP(payload).subscribe(
      (res: any) => {
        this.spinner.hide('main');
        // this.captchaResponse = ''
        // this.googleCaptcha.resetCaptcha();
        if (res?.msg) {
          //  OTP Verified Successfully
          this.toastr.success(res.msg);
          this.showOtp = false;
          this.isTimerVisible = false;
          this.modalService.dismissAll(); // Close modal on success
        } else {
          //  Invalid OTP - Enable "Resend" immediately
          this.errorMessage = "Invalid OTP. Please try again.";
          this.isVerifyEnabled = false; //  Disable Verify
          this.isResendEnabled = true; //  Enable Resend
          this.isTimerVisible = false; // Hide countdown
          this.showOtp = true;
          clearInterval(this.interval); // Stop timer

        }
      },
      (error: any) => {
        this.spinner.hide('main');
        // this.captchaResponse = ''
        // this.googleCaptcha.resetCaptcha();
        this.showOtp = true;
        this.toastr.error(error?.msg || 'Something went wrong');
        this.isVerifyEnabled = false; //  Disable Verify button
        this.isResendEnabled = true; //  Enable Resend button immediately
        this.isTimerVisible = false; // Hide countdown
        clearInterval(this.interval); // Stop timer

      }
    );
  }

  // 🔄 Handle Resend OTP (Call getOTP API and restart timer)
  resendOTP() {
    this.isResendEnabled = false;
    this.generateOTP(); //  Call API to request a new OTP
  }

  // ⏳ Start the 3-minute countdown timer
  startResendTimer() {
    this.isVerifyEnabled = true; //  Enable Verify button
    this.isResendEnabled = false; //  Disable Resend button
    this.isTimerVisible = true;

    this.interval = setInterval(() => {
      this.countdown--;

      if (this.countdown <= 0) {
        clearInterval(this.interval);
        this.isResendEnabled = true; //  Enable Resend button
        this.isVerifyEnabled = false; //  Disable Verify button
        this.isTimerVisible = false; // Hide Timer
      }
    }, 1000);
  }
  onGSTSelection(option: 'notRegistered' | 'registered') {
    if (option === 'notRegistered') {
      this.gstRegistered = false;
    } else {
      this.gstNotRegistered = false;
    }
  }

  is_gstin_confirm = false;
  confirmAction() {
    this.spinner.show('main');
    if (this.gstNotRegistered) {
      this.is_gstin_confirm = false; // GST not registered
    } else if (this.gstRegistered) {
      this.is_gstin_confirm = true; // GST registered
    }
    let object = {
      app_name: "com.tatamotors.vas.customer",
      token: this.order_number,
      amc_terms_agreement: this.termsAgree,
      data_collection_agreement: this.authorize,
      cif_gstin_confirmed: this.is_gstin_confirm,
    };


    this.dealerService.submitCustomerCIF(object).subscribe(
      (response: any) => {
        this.spinner.hide('main');
        if (response?.msg) {
          this.toastr.success(response.msg);
          this.shoMsg = response.msg;
          this.isError = true;

        }
        this.modalService.dismissAll();
        // this.getCifDetails(this.order_number);
      },
      (error: any) => {
        this.spinner.hide('main');
        this.toastr.error(error?.msg || 'Something went wrong');
      }
    );
  }

  getFormattedTime(): string {
    const minutes = Math.floor(this.countdown / 60);
    const seconds = this.countdown % 60;
    return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  }
  maskMobile(mobile: string): string {
    if (!mobile) return '';
    return mobile.replace(/^(\d{3})\d{3}(\d{4})$/, 'XXX-XXX-$2');
  }

  maskEmail(email: string): string {
    if (!email) return '';
    return email.replace(/^(.{2}).*(@.*)$/, 'XXXX$2');
  }

  formatToDisplay(date: string | null): string {
    return date ? this.datePipe.transform(date, 'dd-MMM-yy') || '' : '';
  }

  getEmiAmount(): number {
    const emiAmount = this.cifDetails?.payment_details?.emi_amount;
    return emiAmount && !isNaN(Number(emiAmount)) ? Number(emiAmount) : 0;
  }

  onCaptchaResolved(captchaResponse: any): void {
    this.captchaResponse = captchaResponse;
    console.log('Captcha resolved:', this.captchaResponse);
  }

}

